export const LOADER_ROW_ID = '__loader__';

/** Separator joining a patient key with a secondary segment in dashboard grid row IDs. */
export const DASHBOARD_ID_SEPARATOR = '::';

/** Full-width row kinds shared by the Curation/Clinical/Reports row models. */
export const DASHBOARD_ROW_TYPE = {
  PATIENT_HEADER: 'patientHeader',
  ACCORDION_SUMMARY: 'accordionSummary',
  LOADER: 'loader',
} as const;

export type DashboardRowType = typeof DASHBOARD_ROW_TYPE[keyof typeof DASHBOARD_ROW_TYPE];

/** Whether an item row sits in the main section or the related (accordion) section. */
export const DASHBOARD_SET_TYPE = {
  MAIN: 'main',
  RELATED: 'related',
} as const;

export type DashboardSetType = typeof DASHBOARD_SET_TYPE[keyof typeof DASHBOARD_SET_TYPE];

export const REVIEW_STATUS = {
  ASSIGNED: 'Assigned',
  READY_FOR_REVIEW: 'Ready for Review',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
} as const;

export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
} as const;

export const REPORT_STATUS = {
  PENDING: 'pending',
  FINALISED: 'finalised',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  READY_TO_SEND: 'ready_to_send',
  SENDING: 'sending',
  SENT: 'sent',
  DONE: 'done',
  FAILED: 'failed',
} as const;
